export const sendAnalytics = function (
  event,
  analytics,
  currentProduct,
  currentPrice
) {
  let form = event.currentTarget;
  let product = _.find(analytics.products, {
    wp_id: currentProduct,
  });

  if (product) {
    let _paq = (window._paq = window._paq || []);

    _paq.push([
      'addEcommerceItem',
      currentProduct, // (Required) productSKU
      product.category, // (Optional) productName
      product.name, // (Optional) productCategory
      parseInt(currentPrice, 10), // (Recommended) price
      1,
    ]);

    _paq.push(['trackEcommerceCartUpdate', parseInt(currentPrice)]);
  }

  if (window.ga && window.ga.answer) {
    if (product) {
      event.preventDefault();
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'EUR',
          add: {
            products: [
              {
                name: product.category,
                price: currentPrice,
                category: product.name,
                quantity: 1,
              },
            ],
          },
        },
        eventCallback: () => {
          form.submit();
        },
      });
    }
  }
};
